import TemplateView from '../../../../TemplateView'

export default class TableRow extends TemplateView {
    constructor({
        cells = []
    }) {
        super(null)

        this.params = {
            cells,
        }

        this.state = {
            enabled: false,
            enabledInOtherProduct: null,
            locked: false,
            isNew: false,
            selected: false,
            hoveredCls: '',
        }

        this.onStateChanged(() => {
            this.$el
                .toggleClass('linkedNotNull', this.state.enabledInOtherProduct !== null)
                .toggleClass('linkedWithActiplans', this.state.enabledInOtherProduct === true)
                .toggleClass('locked', this.state.locked)
                .toggleClass('newUser', this.state.isNew)
                .toggleClass('selected', this.state.selected)
                .toggleClass('disabled', !this.state.enabled)
        })

        this.onStatePropertyChanged('hoveredCls', (cls, prevCls) => {
            this.$el.toggleClass(cls, true).toggleClass(prevCls, false)
        })
    }

    templateHtml() {
        return '<tr class="userListRow"></tr>'
    }

    afterRender() {
        this.params.cells.forEach(cell => {
            cell.init(this.$el)
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/components/TableRow.js